<script>
import LayoutTopbar from './LayoutTopbar.svelte';
import IconHelp from './Icons/IconHelp.svelte';
import styler, {templateStyle} from '../styler';
import * as Config from '../config.json';

export let title;
export let privacyUrl;
export let termsUrl;
export let logo;
export let background;
</script>

<LayoutTopbar {title} {logo} isMain={false}>
  <div class="flex items-center">
    <div class="poweredby mr-4">Powered by | <span>PARALLEL.LIVE</span></div>
    <a href="/help">
      <IconHelp --color="var(--text-primary)" />
    </a>
  </div>
</LayoutTopbar>

<div class="flex flex-col items-center ctent" use:styler={background ? templateStyle({background}) : {}}>
  <slot />
</div>

<div class="footer center-all">
  <div class="flex items-center">
    <a class="link" href={privacyUrl} target="_blank">Privacy Policy</a>
    <!-- svelte-ignore a11y-missing-attribute -->
    <a target={Config.logoLink ? '_blank' : '_self'} href={Config.logoLink || "/"}>
      <img src={logo} />
    </a>
    <a class="link" href={termsUrl} target="_blank">Terms of Use</a>
  </div>
</div>

<style lang="scss">
@import '../util';

$footerHeight: 72px;

.poweredby {
  font-size: 20px;
  font-weight: 300;

  span {
    font-weight: 800;
  }

  @include mobile {
    display: none;
  }
}

.footer {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  height: $footerHeight;
  background-color: var(--primary);
  color: var(--text-primary);
  padding: 0 40px;
  font-size: 16px;
  font-weight: 350;
}

.footer img {
  height: 38px;
  padding: 0 12px;

  @include mobile {
    display: none;
  }
}
.footer .link {
  margin: 0 40px;
  white-space: nowrap;

  @include mobile {
    margin: 0 20px;
  }
}

.ctent {
  background-size: cover;
  background-position: center;
  // background-image: $registration-background;
  background-attachment: fixed;
  min-height: 100vh;

  margin-top: 5rem;
  padding: 2rem 0 calc(2rem + #{$footerHeight}) 0;
  
  @include landscape {
    padding: 2rem 0 $footerHeight 0;
  }
}
</style>